import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formats a number as a price in euros.
 * @param amount - The amount to format.
 * @returns A string representing the formatted price in euros.
 */
export function formatPrice(amount?: number): string {
  if (amount === undefined) amount = 0;
  return `€${amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}

export async function imageToDataUri(url: string) {
  try {
    // Fetch the image as a Blob
    const response = await fetch(url);
    const blob = await response.blob();

    // Create a FileReader to convert the Blob to a Base64 encoded data URI
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error converting image to data URI:", error);
  }
}
